import { env } from '@/helpers';

class DataLayer {
    private layer: undefined | Record<string, any> = undefined;

    private queue: Array<Array<any>> = [];

    private queueNext: Array<Array<any>> = [];

    private layerName: string | null = null;

    private layerFn: string | undefined;

    private checkerFn: undefined | (() => boolean);

    constructor(layerName: string, fn: string | undefined = undefined, checkerFn: undefined | (() => boolean) = undefined) {
      this.layerName = layerName;
      this.checkerFn = checkerFn;

      if (fn) {
        this.layerFn = fn;
      }
    }

    public push(...params: any): void {
      // console.info(`${this.layerName}${this.layerFn ? '.' : ''}${this.layerFn || ''}:`, ...params);
      this.setLayer();

      if (this.layer !== undefined) {
        if (this.layerFn) {
          this.layer[this.layerFn](...params);
        } else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.layer(...params);
        }
      } else {
        this.queue.push(...params);
      }
    }

    public toNext(...params: any): void {
      this.queueNext.push(params);
    }

    public pushNext() {
      this.queueNext = this.queueNext.filter((params) => {
        this.push(...params);

        return false;
      });
    }

    private runQueue() {
      this.queue = this.queue.filter((params) => {
        this.push(...params);

        return false;
      });
    }

    private setLayer() {
      if (this.layer !== undefined && this.layerName !== null) return;

      const allowedToPush = typeof this.checkerFn === 'function' ? this.checkerFn() : true;
      if (!allowedToPush) return;

      const layer = (window as Record<string, any>)[this.layerName as string];

      if (typeof layer !== 'undefined') {
        this.layer = layer;

        this.runQueue();
      }
    }
}

const defaultGAInstance = new DataLayer(env('GA_DATALAYER_VAR', '') as string, 'push', () => {
  const hasUsercentrics = !!env('USERCENTRICS_SETTINGS_ID');
  if (hasUsercentrics) {
    return window.ucConsentStatus[env('GA_CONSENT_KEY', 'Google Analytics') as string] === 1;
  }

  return true;
});

export {
  // eslint-disable-next-line import/prefer-default-export
  defaultGAInstance as DataLayer,
};
